import ReportPage from './reportPage'

export default ReportPage